export const TableHeader = [
    // { field: "createdAt", title: "DATE/TIME", width: 100 },
	{ field: "firstName", title: "FIRST NAME", width: 100 },
	{ field: "lastName", title: "LAST NAME", width: 100 },
    { field: "email", title: "EMAIL", width: 100 },
    { field: "schemeCode", title: "SCHEME CODE", width: 100 },
    { field: "approve", title: "APPROVAL", width: 120 },
    { field: "viewScheme", title: "ACTION", sortable: false, width: 70 },
]

export const dummyData = [
    {
        objectId:1,
        firstName:"Timilehin",
        lastName:"Adeyemi",
        email:"timi@gmail.com",
        schemeCode:"TNNN-1233",
        approve:"Approved"
    },
    {
        objectId:2,
        firstName:"Timilehin",
        lastName:"Adeyemi",
        email:"timi@gmail.com",
        schemeCode:"TNNN-1233",
        approve:"Approved"
    },

    {
        objectId:3,
        firstName:"Timilehin",
        lastName:"Adeyemi",
        email:"timi@gmail.com",
        schemeCode:"TNNN-1233",
        approve:"Approved"
    },
]